export default __webpack_public_path__ + "c5f9e9fc402a3f713dc899ffc69de71d.svg";